/** Тег ищем явно: экспорт bpmn-js начинается с XML-пролога и DOCTYPE, а не с разметки. */
export const getSvgViewBoxSize = (svg?: string): { width: number; height: number } | undefined => {
	const openingTag = svg?.match(/<svg\b[^>]*>/)?.[0];
	const viewBox = openingTag?.match(/viewBox="\s*[\d.+-]+[\s,]+[\d.+-]+[\s,]+([\d.+-]+)[\s,]+([\d.+-]+)/);
	if (!viewBox) return undefined;

	const width = Number(viewBox[1]);
	const height = Number(viewBox[2]);
	if (!(width > 0) || !(height > 0)) return undefined;

	return { width, height };
};

const getSvgAspectRatio = (svg?: string): string | undefined => {
	const size = getSvgViewBoxSize(svg);
	return size && `${size.width} / ${size.height}`;
};

export default getSvgAspectRatio;
